import { Component, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {
  @Input() helpText: string;
  @Input() isDisabled: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() displayWide: boolean = false;
  hasLabel: boolean = false;
  showTooltip: boolean = false;
  transform: string = '';
  elementRef: ElementRef;
  @ViewChild('tooltipRef') tooltipRef: ElementRef;
  @ViewChild('tooltipOverlay') tooltipOverlay: ElementRef;

  constructor(element_ref: ElementRef) {
    this.elementRef = element_ref;
  }

  ngAfterContentInit() {
    // after the content has loaded, check if the 'label' div exists, and set the flag appropriately
    this.hasLabel = !!this.elementRef.nativeElement.querySelector('[label]');
  }

  viewTooltip(event): void {
    this.calculateTooltipOffset(event);
    this.showTooltip = true;
  }

  hideTooltip(): void {
    this.showTooltip = false;
    const script = document.getElementById('tooltip-pseudo-style');
    if (script) {
      script.remove();
    }
  }

  toggleTooltip(event: TouchEvent): void {
    if (!this.isFromTooltipContent(event)) {
      this.calculateTooltipOffset(event);
      this.showTooltip = !this.showTooltip;
    }
  }

  isFromTooltipContent(event: Event): boolean {
    return this.tooltipOverlay.nativeElement.contains(event.target);
  }

  // For small screens, calculate an offset to make sure the tooltip does not go off screen
  calculateTooltipOffset(event) {
    const baseOffset = 132;
    const viewTooltipGap = 25;

    const bodyWidth = document.body.getBoundingClientRect().width;
    const { left: labelXPosition, width: labelWidth } = this.tooltipRef.nativeElement.getBoundingClientRect();

    const isLeftOffScreen = labelXPosition + labelWidth / 2 < baseOffset;
    const isRightOffScreen = labelXPosition + labelWidth / 2 + baseOffset > bodyWidth;

    let tooltipOffset = baseOffset - labelWidth / 2;
    if (isLeftOffScreen) {
      tooltipOffset = labelXPosition - viewTooltipGap;
    }
    if (isRightOffScreen) {
      tooltipOffset = labelXPosition + baseOffset * 2 - bodyWidth + viewTooltipGap;
    }

    this.transform = `translate3d(${-tooltipOffset}px, 0, 0)`;
  }

  handleClick(event) {
    let clickedComponent = event.target;
    let inside = false;
    do {
      if (clickedComponent === this.elementRef.nativeElement) {
        inside = true;
      }
      clickedComponent = clickedComponent.parentNode;
    } while (clickedComponent);
    if (!inside) {
      this.showTooltip = false;
    }
  }

  getClasses(): string {
    if (this.showTooltip && this.displayWide) {
      return 'tooltip__overlay--visible tooltip__overlay--visible-wide';
    } else if (this.showTooltip) {
      return 'tooltip__overlay--visible';
    } else {
      return 'tooltip__overlay';
    }
  }
}
